// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_CHARTS_BY_PROFILE_COUNT_HEADING = "Najpopul\u00e1rnej\u0161ie ko\u010d\u00edky";
export const STROLLERS_CHARTS_BY_USER_SCORE_DESCRIPTION = "Ko\u010d\u00edk mus\u00ed ma\u0165 aspo\u0148 5 hodnoten\u00ed.";
export const STROLLERS_CHARTS_BY_USER_SCORE_HEADING = "Najlep\u0161ie hodnoten\u00e9 ko\u010d\u00edky";
